const bottle_40oz_logo_overlay = {
  desktop: {
    top: "45%",
    left: "27%",
    width: "25%",
    height: "25%",
  },
  mobile: {
    top: "35%",
    left: "27%",
    height: "25%",
    width: "25%",
  },
};

const tumbler_logo_overlay = {
  desktop: {
    top: "32%",
    left: "50%",
    height: "20%",
    width: "20%",
  },
  mobile: {
    top: "22%",
    left: "50%",
    height: "20%",
    width: "20%",
  },
};

const travel_mug_logo_overlay = {
  desktop: {
    top: "43%",
    left: "43%",
    height: "20%",
    width: "20%",
  },
  mobile: {
    top: "30%",
    left: "43%",
    height: "20%",
    width: "20%",
  },
};

export const logoOverlay = {
  "Custom 40oz Bottles": bottle_40oz_logo_overlay,
  "Organization 40oz Bottles": bottle_40oz_logo_overlay,
  "Custom 20oz Bottles": bottle_40oz_logo_overlay,
  "Organization 20oz Bottles": bottle_40oz_logo_overlay,
  "Custom Tumblers": tumbler_logo_overlay,
  "Organization Tumblers": tumbler_logo_overlay,
  "Custom Travel Mugs": travel_mug_logo_overlay,
  "Organization Travel Mugs": travel_mug_logo_overlay,
  "Custom Hoodies": {
    desktop: {
      top: "40%",
      left: "50%",
      height: "45%",
      width: "45%",
    },
    mobile: {
      top: "35%",
      left: "50%",
      height: "45%",
      width: "45%",
    },
  },
  "Custom T-Shirts": {
    desktop: {
      top: "40%",
      left: "50%",
      height: "40%",
      width: "40%",
      fontSize: 25,
    },
    mobile: {
      top: "30%",
      left: "50%",
      height: "40%",
      width: "40%",
    },
  },
  "Custom Racerbacks": {
    desktop: {
      top: "40%",
      left: "50%",
      height: "45%",
      width: "45%",
    },
    mobile: {
      top: "35%",
      left: "52%",
      height: "45%",
      width: "45%",
    },
  },
} as const;

const bottle_40oz_text_overlay = {
  desktop: {
    top: "42%",
    left: "35%",
    width: "75%",
    height: "20%",
    baseFontSize: 13,
    transform: "rotate(90deg)",
  },
  mobile: {
    top: "30%",
    left: "35%",
    width: "70%",
    height: "20%",
    baseFontSize: 14,
    transform: "rotate(90deg)",
  },
};

const tumbler_text_overlay = {
  desktop: {
    top: "47%",
    left: "48%",
    width: "35%",
    height: "5%",
    baseFontSize: 8,
  },
  mobile: {
    top: "35%",
    left: "48%",
    width: "25%",
    height: "5%",
    baseFontSize: 12,
  },
};

const travel_mug_text_overlay = {
  desktop: {
    top: "55%",
    left: "42%",
    width: "28%",
    height: "10%",
    baseFontSize: 6,
  },
  mobile: {
    top: "40%",
    left: "42%",
    width: "28%",
    height: "10%",
    baseFontSize: 8,
  },
};

export const textOverlay = {
  "Custom 40oz Bottles": bottle_40oz_text_overlay,
  "Organization 40oz Bottles": bottle_40oz_text_overlay,
  "Custom 20oz Bottles": bottle_40oz_text_overlay,
  "Organization 20oz Bottles": bottle_40oz_text_overlay,
  "Custom Tumblers": tumbler_text_overlay,
  "Organization Tumblers": tumbler_text_overlay,
  "Custom Travel Mugs": travel_mug_text_overlay,
  "Organization Travel Mugs": travel_mug_text_overlay,
} as const;
